<template>
  <div>
    <h2 class="mb-3">
      {{ t('parcelInformation') }}
    </h2>
    <ul class="parcel-info d-flex">
      <li>
        <span class="d-block text-black-50">
          {{ t('weight') }}
        </span>
        {{ itemData.weight }} g
      </li>
      <li>
        <span class="d-block text-black-50">
          {{ t('height') }}
        </span>
        {{ itemData.height }} cm
      </li>
      <li>
        <span class="d-block text-black-50">
          {{ t('length') }}
        </span>
        {{ itemData.length }} cm
      </li>
      <li>
        <span class="d-block text-black-50">
          {{ t('width') }}
        </span>
        {{ itemData.width }} cm
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import type { TrackingData } from '@/types/Models/Shipment'
import { defineComponent, type PropType } from 'vue'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  name: 'DimensionsInfo',
  props: {
    itemData: {
      type: Object as PropType<TrackingData>,
      required: true,
    },
  },
  setup() {
    const { t } = useI18n()

    return {
      t,
    }
  },
})
</script>
